export default __webpack_public_path__ + "static/media/order-arrived-at-destination2.9707c36f.svg";